export default "__VITE_ASSET__CEsAx2B0__"